import angular from 'angular';
import localStorage from 'angular-local-storage';
import tenantConfig from '../tenant-config';
import service from './service';

const app = angular.module('klLocalStorage', [localStorage, tenantConfig]).config([
  'localStorageServiceProvider',
  function (localStorageServiceProvider) {
    localStorageServiceProvider.setPrefix('kl');
  },
]);

service(app);

export default app.name;
